'use strict';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

/**
 * Noop function.
 *
 * @function
 * @returns {void}
 * @example
 * noop();
 * // => undefined
 */
var noop = function noop() {};

noop.HELPER_ID = 'Gearz.JsUtils.noop';
noop.returnType = undefined;
noop.parameterTypes = {};
noop.defaultParameters = {};

module.exports = noop;
